export default __webpack_public_path__ + "static/media/u.25ea1655.mp4";